<template>
<v-dialog :fullscreen="$vuetify.breakpoint.mobile"
          :value="value" :style="{ borderRadius: '50px' }"
          scrollable max-width="80%"
          persistent>
  <v-card class="d-flex flex-column">
    <v-card-title class="primary white--text">
      {{getTitle}}
      <v-spacer/>
      <v-btn text elevation="0" color="white" small @click="$emit('input', false)">
        Fechar <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-divider/>
    <v-card-text class="py-4 flex-grow-1" 
      style="height: 80%;"
      v-if="value">

      <v-container>

        <v-expansion-panels
          v-model="panel"
          multiple expanded>
          <v-expansion-panel :key="0" class="ma-2 rounded-border">
            <v-expansion-panel-header class="titulo">
              <div class="d-flex align-center mb-4">
                <v-icon color="primary" class="mr-2">mdi-sitemap-outline</v-icon>
                <h2 class="text-h6 primary--text">Dados</h2>
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <!-- Seção 1: Dados do Demanda -->
              <div class="mb-6">
                <v-row>
                  <v-col cols="12" md="8">
                    <div class="info-card">
                      <div class="info-label">Comprador</div>
                      <div class="info-value">{{ getItemValue('descricaoCompradorSemCnpj') }}</div>
                    </div>
                  </v-col>
                  <v-col cols="12" md="4">
                    <div class="info-card">
                      <div class="info-label">Data de Expiração</div>
                      <div class="info-value">{{ getItemValue('dataExpiracao') }}</div>
                    </div>
                  </v-col>
                  <v-col cols="12" md="3">
                    <div class="info-card">
                      <div class="info-label">Tipo do Item</div>
                      <div class="info-value">{{ getItemValue('descricaoTipoItemOferta') }}</div>
                    </div>
                  </v-col>
                  <v-col cols="12" md="5">
                    <div class="info-card">
                      <div class="info-label">Item Demandado</div>
                      <div class="info-value">{{ getItemValue('descricaoOferta') }}</div>
                    </div>
                  </v-col>
                  <v-col cols="12" md="4">
                    <div class="info-card">
                      <div class="info-label">Situação</div>
                      <div class="info-value">{{ getItemValue('descricaoStatus') }}</div>
                    </div>
                  </v-col>  
                  <v-col cols="12" md="12">
                    <div class="info-card info-card--multiline">
                      <div class="info-label">Descrição da Demanda</div>
                      <div class="info-value info-value--multiline">{{ getItemValue('descricao') }}</div>
                    </div>
                  </v-col>
                </v-row>          
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel :key="1" class="ma-2 rounded-border">
            <v-expansion-panel-header class="titulo">
              <div class="d-flex align-center mb-4">
                <v-icon color="primary" class="mr-2">mdi-map-marker</v-icon>
                <h2 class="text-h6 primary--text">Que podem se candidatar</h2>
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <!-- Seção 3: Contato/Localização -->
              <div>
                <v-row>
                  <v-col cols="12" md="12">
                    <div class="info-card info-card--multiline">
                      <div class="info-label">Estados</div>
                      <div v-if="estadosList.length" class="estados-lista">
                        <v-chip
                          v-for="(estado, index) in estadosList"
                          :key="`${estado}-${index}`"
                          small
                          outlined
                          color="primary"
                          class="mr-2 mb-2"
                        >
                          {{ estado }}
                        </v-chip>
                      </div>
                      <div v-else class="info-value">Não informado</div>
                    </div>
                  </v-col>            
                </v-row>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>                  
        </v-expansion-panels>

      </v-container>
  
    </v-card-text>
  </v-card>
  <v-overlay :value="loading" absolute>
    <v-progress-circular
      indeterminate
      color="primary"
      class="ma-4"
    ></v-progress-circular>
  </v-overlay>    
</v-dialog>
</template>

<script>
export default {
  name: "DetalheDemandaDialog",
  props: ['value','item'],
  data () {
    return {
      formValid: false,
      loading: false,
      panel: [0,1],
    }
  },
  computed: {
    getTitle() {
      return 'Detalhes da Demanda'
    },
    estadosList() {
      if (!this.item || !this.item.descEstados) {
        return []
      }

      return this.item.descEstados
        .split(',')
        .map(estado => estado.trim())
        .filter(Boolean)
    }
  },
  methods: {
    getItemValue(field) {
      if (!this.item || !this.item[field]) {
        return 'Não informado'
      }

      return this.item[field]
    },
  },
}
</script>

<style scoped>
.info-card {
  border: 1px solid #e6e6e6;
  border-radius: 8px;
  background: #fafafa;
  padding: 10px 12px;
  height: 100%;
}

.info-card--multiline {
  min-height: 88px;
}

.info-label {
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #6f6f6f;
  margin-bottom: 4px;
}

.info-value {
  font-size: 0.94rem;
  color: #222;
  line-height: 1.45;
}

.info-value--multiline {
  white-space: pre-line;
}

.estados-lista {
  display: flex;
  flex-wrap: wrap;
}

</style>